import { isIos } from './notify-platform';

/**
 * VISSZA-HUZAS a kepernyo bal szelerol - telepitett iPhone-appban (K2).
 *
 * A Safari a bal szelrol jobbra huzasra visszalep, a kezdokepernyore tett
 * web-app viszont NEM: ott nincs se vissza gomb, se vissza-gesztus. Aki az
 * iPhone-hoz szokott, ezzel probalkozik eloszor, es semmi nem tortenik.
 *
 * Itt potoljuk: a szelrol inditott, dontoen vizszintes huzas az elozmenyben
 * visszalep - ugyanugy, mint Androidon a rendszer gesztusa. Igy a nyitott
 * parbeszedet, panelt is ez zarja elobb (lib/back-to-close.ts).
 *
 * Androidon es a bongeszos Safariban nem kell: ott a rendszer intezi, es
 * ket egymasra futo vissza-lepes egyszerre ket lepest ugrana.
 */

/** A szel szelessege, ahonnan a huzasnak indulnia kell. */
const EDGE_PX = 24;
/** Legalabb ennyit kell jobbra huzni. */
const MIN_DISTANCE_PX = 70;

function standalone(): boolean {
  return (
    window.matchMedia('(display-mode: standalone)').matches ||
    (navigator as Navigator & { standalone?: boolean }).standalone === true
  );
}

export function installEdgeSwipeBack(back: () => void): void {
  if (typeof window === 'undefined' || !isIos() || !standalone()) return;

  let start: { x: number; y: number } | null = null;

  window.addEventListener(
    'touchstart',
    (event) => {
      const touch = event.touches[0];
      start =
        event.touches.length === 1 && touch && touch.clientX <= EDGE_PX
          ? { x: touch.clientX, y: touch.clientY }
          : null;
    },
    { passive: true },
  );

  window.addEventListener(
    'touchend',
    (event) => {
      const touch = event.changedTouches[0];
      if (!start || !touch) return;
      const dx = touch.clientX - start.x;
      const dy = Math.abs(touch.clientY - start.y);
      start = null;
      if (dx >= MIN_DISTANCE_PX && dy < dx / 2) back();
    },
    { passive: true },
  );

  window.addEventListener('touchcancel', () => (start = null), { passive: true });
}
